import { apiClient } from '../config';
import { endpoints } from '../endpoints';

/**
 * Committee service for handling committee member operations
 */
export const committeeService = {
  /**
   * Get all committee members
   * @returns {Promise<Array>} - Promise resolving to array of committee members
   */
  getAllMembers: async () => {
    const response = await apiClient.get(endpoints.committee.getAll);
    return response.data;
  },

  /**
   * Get committee member by ID
   * @param {string} id - Member ID
   * @returns {Promise<Object>} - Promise resolving to member data
   */
  getMemberById: async (id) => {
    const response = await apiClient.get(endpoints.committee.getById(id));
    return response.data;
  },

  /**
   * Create a new committee member
   * @param {FormData} memberData - FormData containing member information and profile picture
   * @returns {Promise<Object>} - Promise resolving to created member
   */
  createMember: async (memberData) => {
    const response = await apiClient.post(endpoints.committee.create, memberData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /**
   * Update an existing committee member
   * @param {string} id - Member ID
   * @param {FormData} memberData - FormData containing updated member information
   * @returns {Promise<Object>} - Promise resolving to updated member
   */
  updateMember: async (id, memberData) => {
    const response = await apiClient.put(endpoints.committee.update(id), memberData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /**
   * Delete a committee member
   * @param {string} id - Member ID
   * @returns {Promise<Object>} - Promise resolving to success message
   */
  deleteMember: async (id) => {
    const response = await apiClient.delete(endpoints.committee.delete(id));
    return response.data;
  },

  /**
   * Reorder committee members
   * @param {Array<string>} memberIds - Array of member IDs in the desired order
   * @returns {Promise<Array>} - Promise resolving to reordered members
   */
  reorderMembers: async (memberIds) => {
    const response = await apiClient.post(endpoints.committee.reorder, { memberIds });
    return response.data;
  },
};
